import { getItem } from '@/utils/StorageManager'
const accessToken = getItem('accessToken') // store.state.auth.accountId;

const storageManagerConfig = (autoload, urlStore, urlLoad) => {
  let loading = false

  return {
    id: '',
    type: 'remote',
    stepsBeforeSave: 3,
    autosave: false,
    autoload: autoload,
    urlStore: urlStore,
    urlLoad: urlLoad,
    loading: loading,
    // For custom parameters/headers on requests
    contentTypeJson: true,
    credentials: 'omit',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  }
}

export { storageManagerConfig }
